import React, {useEffect, useState, useRef} from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import {Form, Button, message, Skeleton, Row, Space} from 'antd';
import {cerrarNomina} from '../../../../apis/ProcesoNominaApi';
import {emit} from '../../../../apis/TimbradoApi';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import {status_period} from '@app/constants/period';
import _ from 'lodash'
import Result from './result'

const routes = [
  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Timbrado Periodo</span>
      </>
    ),
  }];

const TimbradoPeriodo = () => {
  const [ form ] = Form.useForm()
  const [ loading, setLoading ] = useState(false);
  const [objectSelected, setObjectSelected] = useState(null);
  const [disabledForm, setDisabled] = useState(true);
  const [header, setHeader] = useState(null);
  
  const [period, setPeriod] = useState(null);
  
  const onBlurHeader = async (values, period)=> {
    setHeader(values)
    if(values?.anio && values?.num_periodo && values?.periodo_id){
      setDisabled(false);
    }else{
      setDisabled(true);
    }
    
    if(period){
      setPeriod(period);
    }else{
      setPeriod(null)
    }
  }
  
  const onCancelarTodasNominas = () => {
    // Aquí va la lógica para cancelar todas las nóminas del periodo
    console.log('Cancelando todas las nóminas del periodo');
  }

  return (
    <PageApp
      routes={routes}
      title={'Timbrado Periodo'}>
      
      <AnioPeriodo onBlur={onBlurHeader} form={form} disabledForm={objectSelected && objectSelected.id > 0}/>
      <br/>
      
      {/* Botón para cancelar todas las nóminas - movido arriba */}
      {header && !disabledForm && (
        <Row justify="end" style={{ marginBottom: 16 }}>
          <Button danger type="primary" onClick={onCancelarTodasNominas}>
            Cancelar Todas las Nóminas
          </Button>
        </Row>
      )}
      
      {
        loading ? <Skeleton active={loading} /> : (
          <>
            {
              header && !disabledForm && (
                <Result header={header} />
              )
            }
          </>
        )
      }
    </PageApp>
  );
}

export default TimbradoPeriodo;